import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import WrappedRoute from './WrappedRoute';
import Home from '../routes/Home';
import ContactUs from '../routes/ContactUs';
import AboutUs from '../routes/AboutUs';
import Login from '../routes/Login';
import Signup from '../routes/Signup';
import ForgetPassword from '../routes/ForgetPassword';
import Dashboard from '../routes/Dashboard';
import VehicleRegister from '../routes/VehicleRegister';
import JobRegister from '../routes/JobRegister';
import AgencyRegister from '../routes/AgencyRegister';
import GalleryRegister from '../routes/GalleryRegister';
import AlarmRegister from '../routes/AlarmRegister';
import AgencyAds from '../routes/AgencyAds';
import GalleryAds from '../routes/GalleryAds';
import VehicleAds from '../routes/VehicleAds';
import JobAds from '../routes/JobAds';
import VehicleDetails from '../routes/VehicleDetails';
import JobDetails from '../routes/JobDetails';
import AgencyDetails from '../routes/AgencyDetails';
import GalleryDetails from '../routes/GalleryDetails';
import AlarmDetails from '../routes/AlarmDetails';
import VehicleAdFilters from '../routes/VehicleAdFilters';
import NotFound from '../routes/NotFound';
const AppRouter = () => (
    <div>
        <BrowserRouter>
            <Switch>
                <WrappedRoute path='/' component={Home} exact={true}/>
                <WrappedRoute path='/contact-us' component={ContactUs} exact={true}/>
                <WrappedRoute path='/about-us' component={AboutUs} exact={true}/>
                <WrappedRoute path='/agencies' component={AgencyAds} exact={true}/>
                <WrappedRoute path='/galleries' component={GalleryAds} exact={true}/>
                <WrappedRoute path='/vehicles' component={VehicleAds} exact={true}/>
                <WrappedRoute path='/jobs' component={JobAds} exact={true}/>
                <WrappedRoute path='/vehicle/:id' component={VehicleDetails} exact={true}/>
                <WrappedRoute path='/job/:id' component={JobDetails} exact={true}/>
                <WrappedRoute path='/agency/:id' component={AgencyDetails} exact={true}/>
                <WrappedRoute path='/gallery/:id' component={GalleryDetails} exact={true}/>
                <PrivateRoute path='/alarm/:id' component={AlarmDetails} exact={true}/>
                <WrappedRoute heading='جستجوی‌پیشرفته' path='/vehicle-filters' component={VehicleAdFilters}/>
                <PublicRoute path='/login' component={Login} exact={true}/>
                <PublicRoute path='/signup' component={Signup} exact={true}/>
                <PublicRoute path='/forgot-password' component={ForgetPassword} exact={true}/>
                <PrivateRoute path='/dashboard' component={Dashboard} exact={true}/>
                <PrivateRoute path='/register-vehicle' component={VehicleRegister} exact={true}/>
                <PrivateRoute path='/register-job' component={JobRegister} exact={true}/>
                <PrivateRoute path='/register-agency' component={AgencyRegister} exact={true}/>
                <PrivateRoute path='/register-gallery' component={GalleryRegister} exact={true}/>
                <PrivateRoute path='/register-alarm' component={AlarmRegister} exact={true}/>
                <Route component={NotFound}/>
            </Switch>
        </BrowserRouter>
    </div>
)

export default AppRouter;